<template>
    <footer style="width: 100%;top: 0px;">
        <a href="https://asso-refuge.fr/" target="_blank" 
            style="text-decoration: none; color: inherit; font-weight: normal; font-family: inherit;">
            © 2025 Copyright - Les - Refuges  
                    
          
        </a>
    </footer>
</template>
<style src="../assets/css/header.css"></style>